import React from 'react';

interface DownloadIconProps extends React.SVGProps<SVGSVGElement> {
	width?: number;
	height?: number;
	fill?: string;
}

export function DownloadIcon({
	width = 24,
	height = 24,
	fill = 'currentColor',
	...props
}: Readonly<DownloadIconProps>): JSX.Element {
	return (
		<svg
			{...props}
			fill="none"
			width={width}
			height={height}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M11.831 15.9862C11.8511 16.0118 11.8767 16.0325 11.9059 16.0468C11.9352 16.061 11.9673 16.0684 11.9998 16.0684C12.0323 16.0684 12.0644 16.061 12.0937 16.0468C12.1229 16.0325 12.1485 16.0118 12.1685 15.9862L15.1685 12.1907C15.2784 12.0514 15.1793 11.8451 14.9998 11.8451H13.015V2.78083C13.015 2.66297 12.9185 2.56655 12.8007 2.56655H11.1935C11.0757 2.56655 10.9793 2.66297 10.9793 2.78083V11.8424H8.9998C8.82033 11.8424 8.72123 12.0487 8.83105 12.188L11.831 15.9862ZM21.8034 15.0487H20.1962C20.0784 15.0487 19.9819 15.1451 19.9819 15.263V19.388H4.01765V15.263C4.01765 15.1451 3.92123 15.0487 3.80337 15.0487H2.19623C2.07837 15.0487 1.98194 15.1451 1.98194 15.263V20.5665C1.98194 21.0407 2.36498 21.4237 2.83908 21.4237H21.1605C21.6346 21.4237 22.0177 21.0407 22.0177 20.5665V15.263C22.0177 15.1451 21.9212 15.0487 21.8034 15.0487Z"
				fill={fill}
			/>
		</svg>
	);
}
